

















import {Component, Prop, Vue} from 'vue-property-decorator'
import Registration from '@/components/Registration.vue'
import {Action, State} from 'vuex-class'
import {RegistrationRequest} from '@/store/modules/registration' // @ is an alias to /src

@Component({
  components: {
    Registration,
  },
})
export default class Home extends Vue {
  @State('registration') public registration!: RegistrationRequest
  @State((state) => state.registration.client_token) public token!: string
  @Action('updateRegistration') public updateRegistration: any

  // TODO: aggiungere 'sei stato invitato come driver'
  private mounted() {
    if (this.$route.query.hasOwnProperty('token')) {
      this.updateRegistration({client_token: this.$route.query.token}).then(
        () => {
          this.$router.replace({path: '/'})
        },
      )
    }
  }
}
